(function () {
  document.addEventListener('DOMContentLoaded', initSearchModal);

  function initSearchModal() {
    var modal = document.querySelector('[data-wbx-search-modal]');
    if (!modal) return;

    var triggers = document.querySelectorAll('[data-wbx-search-open]');
    var closers = modal.querySelectorAll('[data-wbx-search-close]');
    var input = modal.querySelector('[data-wbx-search-input]');
    var resultsEl = modal.querySelector('[data-wbx-search-results]');

    var fetchController = null;
    var debounceTimer = null;

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wbx-search-open');
      setTimeout(function () {
        if (input) input.focus();
      }, 50);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wbx-search-open');
      if (fetchController) fetchController.abort();
    }

    // Hook trigger buttons
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    // Close handlers
    closers.forEach(function (c) {
      c.addEventListener('click', closeModal);
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    // Input handler with debounce
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();

        clearTimeout(debounceTimer);

        if (q.length < 2) {
          if (fetchController) fetchController.abort();
          renderHint();
          return;
        }

        debounceTimer = setTimeout(function () {
          search(q);
        }, 250);
      });
    }

    function search(q) {
      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      renderLoading();

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=article,page,product' +
                '&resources[limit]=10' +
                '&resources[options][unavailable_products]=last';

      fetch(url, { signal: fetchController.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('Search request failed');
          return r.json();
        })
        .then(function (data) {
          renderResults(data.resources && data.resources.results, q);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          renderError();
        });
    }

    function renderHint() {
      resultsEl.innerHTML =
        '<div class="wbx-search-modal__hint"><p>Start typing to search across blog posts, pages, and more.</p></div>';
    }

    function renderLoading() {
      resultsEl.innerHTML =
        '<div class="wbx-search-modal__loading">Searching…</div>';
    }

    function renderError() {
      resultsEl.innerHTML =
        '<div class="wbx-search-modal__empty">Search failed. Please try again.</div>';
    }

    function renderResults(results, q) {
      if (!results) {
        renderError();
        return;
      }

      var articles = results.articles || [];
      var pages = results.pages || [];
      var products = results.products || [];
      var total = articles.length + pages.length + products.length;

      if (total === 0) {
        resultsEl.innerHTML =
          '<div class="wbx-search-modal__empty">No results for <strong>"' + escapeHtml(q) + '"</strong></div>';
        return;
      }

      var html = '';

      if (articles.length) {
        html += renderGroup('Blog Posts', articles, 'article');
      }
      if (pages.length) {
        html += renderGroup('Pages', pages, 'page');
      }
      if (products.length) {
        html += renderGroup('Products', products, 'product');
      }

      html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="wbx-search-modal__view-all">View all results for "' + escapeHtml(q) + '"</a>';

      resultsEl.innerHTML = html;
    }

    function renderGroup(label, items, type) {
      var html = '<div class="wbx-search-modal__group">';
      html += '<div class="wbx-search-modal__group-label">' + label + '</div>';

      items.forEach(function (item) {
        var url = item.url || '#';
        var title = item.title || 'Untitled';
        var summary = '';

        if (type === 'article') {
          summary = item.summary || item.content || '';
        } else if (type === 'page') {
          summary = item.body || '';
        } else if (type === 'product') {
          summary = item.body || item.description || '';
        }

        // strip html and truncate
        summary = stripHtml(summary).substring(0, 120);

        var thumbHtml = '';
        var thumbIcon = type === 'article' ? '📰' : type === 'page' ? '📄' : '🛍️';

        if (item.image) {
          thumbHtml = '<img src="' + item.image + '" alt="" loading="lazy">';
        } else if (item.featured_image && item.featured_image.url) {
          thumbHtml = '<img src="' + item.featured_image.url + '" alt="" loading="lazy">';
        } else {
          thumbHtml = '<span class="wbx-search-modal__result-thumb-icon">' + thumbIcon + '</span>';
        }

        html += '<a href="' + url + '" class="wbx-search-modal__result">';
        html += '<div class="wbx-search-modal__result-thumb">' + thumbHtml + '</div>';
        html += '<div class="wbx-search-modal__result-content">';
        html += '<h4 class="wbx-search-modal__result-title">' + escapeHtml(title) + '</h4>';
        if (summary) {
          html += '<p class="wbx-search-modal__result-snippet">' + escapeHtml(summary) + '</p>';
        }
        html += '</div></a>';
      });

      html += '</div>';
      return html;
    }

    function stripHtml(str) {
      if (!str) return '';
      var tmp = document.createElement('div');
      tmp.innerHTML = str;
      return tmp.textContent || tmp.innerText || '';
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
  }
})();
